module.exports = __webpack_public_path__ + "img/logo_text_2027.17d53fe0.jpg";